import { combineReducers } from "@reduxjs/toolkit"
import { commonSlice } from "./common/common.slice"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage";
import { backendApi } from "./dynamicBAseQuery";

const commonPersistConfig = {
    key: "common",
    version: 1,
    storage,
  };
  
  const rootReducer = combineReducers({
    [backendApi.reducerPath]: backendApi.reducer,
    [commonSlice.name]: persistReducer(commonPersistConfig, commonSlice.reducer),
  });
  
  export default rootReducer;